var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneAllOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.273 13.036A.91.91 0 0 1 2 12.35q.012-.392.297-.687a.98.98 0 0 1 .664-.282.86.86 0 0 1 .665.282l3.368 3.483.332.343.333.343q.285.295.272.687-.011.392-.296.687a.98.98 0 0 1-.664.282.86.86 0 0 1-.665-.282zm10.06 2.085 8.065-8.338a.86.86 0 0 1 .664-.283q.38.013.665.307.261.294.273.687a.91.91 0 0 1-.273.686l-8.73 9.026a.896.896 0 0 1-1.33 0l-4.032-4.17a.93.93 0 0 1-.261-.674q0-.405.26-.699a.9.9 0 0 1 .677-.294q.39 0 .676.294zm4.008-6.916-3.345 3.458a.87.87 0 0 1-.652.27.95.95 0 0 1-.676-.27.97.97 0 0 1-.285-.699q0-.405.285-.699l3.345-3.458a.87.87 0 0 1 .652-.27.95.95 0 0 1 .676.27q.285.295.285.699 0 .405-.285.699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAllOutline);
export default __webpack_public_path__ + "static/media/done_all_outline.7e694047b898e8d7460e97075a5b7190.svg";
export { ForwardRef as ReactComponent };